export function resetReCaptcha() {
  // reset() will cause captcha expiry to no longer trigger so have to also remove the token.
  window.grecaptcha?.reset()
  window.tixRecaptchaToken = undefined
}
